/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_auth_signup_email_label = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const en_auth_signup_email_label = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const auth_signup_email_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_signup_email_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("auth_signup_email_label", locale)
	if (locale === "es") return es_auth_signup_email_label(inputs)
	return en_auth_signup_email_label(inputs)
};
export { auth_signup_email_label as "auth.signup.email_label" }